import React, { useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import {
  Collapse,
  Divider,
  IconButton,
  makeStyles,
  Tooltip,
  Typography
} from '@material-ui/core'
import resumoRepository from './resumoRepository'
import Fetching from '../../../components/Fetching'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import clsx from 'clsx'
import { Alert } from '@material-ui/lab'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(6)
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  }
}))

function ResumoCard({ match }) {
  const [resumo, setResumo] = useState(null)
  const [expanded, setExpanded] = useState(true)
  const classes = useStyles()

  useEffect(() => {
    async function fetchData() {
      const solicitacaoId = match.params.id
      const response = await resumoRepository.getResumo(solicitacaoId)
      if (response.ok) {
        setResumo(response.data)
      }
    }
    fetchData()
  }, [match.params.id])

  const handleExpandedClick = () => {
    setExpanded(!expanded)
  }

  const renderListaAlertas = (listaAlertas, size = 12) => {
    return listaAlertas.map((alerta, index) => (
      <Grid item xs={size} key={index}>
        <Alert variant="filled" severity={alerta.cor}>
          {alerta.descricao}
        </Alert>
      </Grid>
    ))
  }

  const renderVerde = verde => {
    if (
      verde.quantidadeViagens ||
      verde.quantidadeUltimasViagens ||
      (verde.avisos && verde.avisos.length)
    ) {
      return (
        <Grid item xs={12} className={classes.verde}>
          <Grid container spacing={2}>
            {verde.quantidadeViagens && (
              <Grid item xs={12}>
                <Alert variant="filled" severity="success">
                  Quantidade Viagens
                </Alert>
              </Grid>
            )}
            {verde.quantidadeUltimasViagens && (
              <Grid item xs={12}>
                <Alert variant="filled" severity="success">
                  Quantidade Últimas Viagens
                </Alert>
              </Grid>
            )}
            {verde.avisos && renderListaAlertas(verde.avisos)}
          </Grid>
        </Grid>
      )
    }
    return (
      <Grid item xs={12}>
        <Typography>Nenhuma Classificação Verde</Typography>
      </Grid>
    )
  }

  const renderVermelho = vermelho => {
    if (
      vermelho.blacklistsBloqueios ||
      vermelho.documentos ||
      (vermelho.avisos && vermelho.avisos.length)
    ) {
      let titleTooltip = []
      try {
        titleTooltip = vermelho.documentos
          ? Object.keys(vermelho.documentos).map(key => key.split(' ')[0])
          : []
        titleTooltip = [...new Set(titleTooltip)]
      } catch (error) {
        console.error('Erro chaves')
      }
      return (
        <Grid item xs={12} className={classes.vermelho}>
          <Grid container spacing={2}>
            {vermelho.blacklistsBloqueios && (
              <Grid item xs={12}>
                <Alert variant="filled" severity="error">
                  BlackList e/ou Bloqueio
                </Alert>
              </Grid>
            )}
            {vermelho.documentos !== null &&
              Object.keys(vermelho.documentos).length > 0 && (
                <Grid item xs={12}>
                  <Tooltip placement="top" title={titleTooltip.join(', ')}>
                    <Alert variant="filled" severity="error">
                      Problema na Validação dos Documentos
                    </Alert>
                  </Tooltip>
                </Grid>
              )}

            {vermelho.avisos && renderListaAlertas(vermelho.avisos)}
          </Grid>
        </Grid>
      )
    }
    return (
      <Grid item xs={12}>
        <Typography>Nenhuma Classificação Vermelha</Typography>
      </Grid>
    )
  }

  const renderAmarelo = amarelo => {
    if (
      amarelo.ano ||
      amarelo.mercadoriaEspecifica ||
      amarelo.mercadoriaValor ||
      amarelo.ufPlacas ||
      amarelo.limiteValor ||
      amarelo.categoriaCNH ||
      (amarelo.avisos && amarelo.avisos.length)
    ) {
      return (
        <Grid item xs={12} className={classes.amarelo}>
          <Grid container spacing={2}>
            {amarelo.ano && (
              <Grid item xs={12} sm={6}>
                <Alert variant="filled" severity="warning">
                  Ano do Veículo
                </Alert>
              </Grid>
            )}
            {amarelo.mercadoriaEspecifica && (
              <Grid item xs={12} sm={6}>
                <Alert variant="filled" severity="warning">
                  Mercadoria Específica
                </Alert>
              </Grid>
            )}
            {amarelo.mercadoriaValor && (
              <Grid item xs={12} sm={6}>
                <Alert variant="filled" severity="warning">
                  Mercadoria de Alto Valor
                </Alert>
              </Grid>
            )}
            {amarelo.ufPlacas && (
              <Grid item xs={12} sm={6}>
                <Alert variant="filled" severity="warning">
                  Placas de Locais Diferentes
                </Alert>
              </Grid>
            )}
            {amarelo.limiteValor && (
              <Grid item xs={12} sm={6}>
                <Alert variant="filled" severity="warning">
                  Valor Maior que Limite
                </Alert>
              </Grid>
            )}
            {amarelo.categoriaCNH && (
              <Grid item xs={12} sm={6}>
                <Alert variant="filled" severity="warning">
                  Categoria CNH não adequada
                </Alert>
              </Grid>
            )}
            {amarelo.avisos && renderListaAlertas(amarelo.avisos, 6)}
          </Grid>
        </Grid>
      )
    }
    return (
      <Grid item xs={12}>
        <Typography>Nenhuma Classificação Amarela</Typography>
      </Grid>
    )
  }

  return (
    <Grid
      container
      direction="row"
      spacing={2}
      justifyContent="flex-start"
      alignItems="center"
    >
      <Grid item lg={1} sm={2} xs={6}>
        <Typography variant="h6">Resumo</Typography>
      </Grid>
      <Grid item lg={10} sm={9} xs={4}>
        <Divider variant="fullWidth" />
      </Grid>
      <Grid item sm={1} xs={2}>
        <Grid container justifyContent="flex-end" alignItems="center">
          <IconButton
            className={clsx(classes.expand, {
              [classes.expandOpen]: expanded
            })}
            onClick={handleExpandedClick}
            aria-expanded={expanded}
            aria-label="Mostrar Mais"
          >
            <ExpandMoreIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          {resumo && (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                {renderVerde(resumo.verde)}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderAmarelo(resumo.amarelo)}
              </Grid>
              <Grid item xs={12} sm={3}>
                {renderVermelho(resumo.vermelho)}
              </Grid>
            </Grid>
          )}
          {!resumo && <Fetching />}
        </Collapse>
      </Grid>
    </Grid>
  )
}

export default React.memo(ResumoCard)
